import React from 'react';
import { tierParentOpacityStyle, tierParentStyle } from '../../style.vs.css';
import type { LoyaltyTierIconProps } from '../..';

export const GoldXL = ({ behavior }: Pick<LoyaltyTierIconProps, 'behavior'>) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="88"
        height="88"
        viewBox="0 0 88 88"
        fill="none"
        className={behavior === 'changeOpacityOnHover' ? tierParentOpacityStyle : tierParentStyle}
    >
        <path
            d="M39.5 2.59808C42.2846 0.990381 45.7154 0.990381 48.5 2.59808L77.6051 19.4019C80.3897 21.0096 82.1051 23.9808 82.1051 27.1962V60.8038C82.1051 64.0192 80.3897 66.9904 77.6051 68.5981L48.5 85.4019C45.7154 87.0096 42.2846 87.0096 39.5 85.4019L10.3949 68.5981C7.61027 66.9904 5.89488 64.0192 5.89488 60.8038V27.1962C5.89488 23.9808 7.61027 21.0096 10.3949 19.4019L39.5 2.59808Z"
            fill="url(#paint0_linear_1934_151681)"
        />
        <path
            d="M40.5 10.0207C42.6658 8.7703 45.3342 8.7703 47.5 10.0207L71.6769 23.9793C73.8427 25.2297 75.1769 27.5406 75.1769 30.0415V57.9585C75.1769 60.4594 73.8427 62.7703 71.6769 64.0207L47.5 77.9793C45.3342 79.2297 42.6658 79.2297 40.5 77.9793L16.3231 64.0207C14.1573 62.7703 12.8231 60.4594 12.8231 57.9585V30.0415C12.8231 27.5406 14.1573 25.2297 16.3231 23.9793L40.5 10.0207Z"
            stroke="url(#paint1_linear_1934_151681)"
            strokeWidth="2.5"
        />
        <path
            d="M57.6872 37.6224C57.81 36.6714 56.7602 36.0148 55.9588 36.5414L51.336 39.5792C51.1428 39.7062 50.8859 39.6728 50.7315 39.5008L44.8348 32.9302C44.3891 32.4335 43.6109 32.4335 43.1652 32.9302L37.2685 39.5008C37.1141 39.6728 36.8572 39.7062 36.664 39.5792L32.0412 36.5414C31.2398 36.0148 30.19 36.6714 30.3128 37.6224L32.2948 52.9697C32.3549 53.4358 32.7518 53.7847 33.2218 53.7847H54.7783C55.2482 53.7847 55.6451 53.4358 55.7052 52.9697L57.6872 37.6224Z"
            fill="url(#paint2_linear_1934_151681)"
        />
        <defs>
            <linearGradient
                id="paint0_linear_1934_151681"
                x1="44"
                y1="0"
                x2="44"
                y2="88"
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#F4DC95" />
                <stop offset="1" stopColor="#AD822B" />
            </linearGradient>
            <linearGradient
                id="paint1_linear_1934_151681"
                x1="44"
                y1="8"
                x2="44"
                y2="80"
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#FEEEC0" />
                <stop offset="0.5" stopColor="#C9A553" />
                <stop offset="1" stopColor="#A37A2F" />
            </linearGradient>
            <linearGradient
                id="paint2_linear_1934_151681"
                x1="44"
                y1="32"
                x2="44"
                y2="53.7847"
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#FFF9E5" />
                <stop offset="1" stopColor="#D9C28C" />
            </linearGradient>
        </defs>
    </svg>
);
